import Footer from "components/Footer";
import Header from "components/Header";
import MainTitle from "components/MainTitle";
import QuickDonate from "components/QuickDonate/QuickDonate";
import { useDispatch, useSelector } from "react-redux";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { RootState } from "redux/rootReducer";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { donationHistoryActions } from "redux/actions/DonationHistory/donationHistoryActions";
import { Spin } from "antd";
import { checkMark, closered, downloadReceipt } from "assets/icons";

const Donations = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const { loginData } = useSelector((state: RootState) => state.loginReducer);

  const userId = loginData?.user?.id;

  useEffect(() => {
    dispatch(donationHistoryActions(userId));
  }, [dispatch, userId]);

  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  const { donationHistoryLoading, donationHistory } = useSelector(
    (state: RootState) => state.donationHistoryReducer
  );

  // console.log(donationHistory);

  return (
    <>
      <Header />

      <main className="relative">
        {/* quick donate  *****************************/}
        <QuickDonate />

        {/* quick donate popup  ***********************/}
        {quickDonateStatus && <QuickDonatePopUp />}

        <MainTitle title={t("Donations")} />

        {/* donations secction ************************/}
        <Spin spinning={donationHistoryLoading}>
          <section
            data-aos="fade-up"
            data-aos-duration="900"
            className={`my-[80px] min-h-[300px] w-full px-[20px] lg:px-0 flex items-center justify-center ${
              i18n.language === "en" ? "font-Poppins" : "font-Almarai"
            } text-[6px] lg:text-[18px]`}
          >
            <div className="mainContainer w-full h-full">
              <table className="min-w-full leading-normal">
                <thead>
                  <tr>
                    <th
                      className={`lg:px-5 lg:py-3 border-b-2 text-left text-[10px] lg:text-[18px] font-[600] text-gray-700 uppercase tracking-wider ${
                        i18n.language === "en" ? "text-left" : "text-right"
                      }`}
                    >
                      {t("S.No")}
                    </th>
                    <th
                      className={`lg:px-5 lg:py-3 border-b-2 text-left text-[10px] lg:text-[18px] font-[600] text-gray-700 uppercase tracking-wider ${
                        i18n.language === "en" ? "text-left" : "text-right"
                      }`}
                    >
                      {t("Project Name")}
                    </th>

                    <th
                      className={`lg:px-5 lg:py-3 border-b-2 text-left text-[10px] lg:text-[18px] font-[600] text-gray-700 uppercase tracking-wider ${
                        i18n.language === "en" ? "text-left" : "text-right"
                      }`}
                    >
                      {t("Amount1")}
                    </th>

                    <th
                      className={`lg:px-5 lg:py-3 border-b-2 text-left text-[10px] lg:text-[18px] font-[600] text-gray-700 uppercase tracking-wider ${
                        i18n.language === "en" ? "text-left" : "text-right"
                      }`}
                    >
                      {t("Date & Time")}
                    </th>

                    <th
                      className={`lg:px-5 lg:py-3 border-b-2 text-left text-[10px] lg:text-[18px] font-[600] text-gray-700 uppercase tracking-wider ${
                        i18n.language === "en" ? "text-left" : "text-right"
                      }`}
                    >
                      {t("Status")}
                    </th>
                    <th
                      className={`lg:px-5 lg:py-3 border-b-2 text-left text-[10px] lg:text-[18px] font-[600] text-gray-700 uppercase tracking-wider ${
                        i18n.language === "en" ? "text-left" : "text-right"
                      }`}
                    >
                      {t("Download receipt")}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {donationHistory?.map((item: any, index: number) => {
                    return (
                      <tr>
                        {/* RECEIPT  ****************/}
                        <td className="lg:px-5 lg:py-5 border-b border-gray-200 bg-white text-[8px] lg:text-[16px] shadow-shadow_main">
                          <div className="flex">
                            <div className="ml-3">
                              <p className="text-black font-[500] whitespace-no-wrap">
                                {index + 1}
                              </p>
                            </div>
                          </div>
                        </td>

                        {/* PROJECT NAME ***************/}
                        <td className="lg:px-5 lg:py-5 border-b border-gray-200 bg-white text-[8px] lg:text-[16px] shadow-shadow_main">
                          <div className="flex">
                            <div className="ml-3">
                              <p className="text-black font-[500] whitespace-no-wrap">
                                {item?.data?.internal_projects
                                  ? i18n.language === "en"
                                    ? item?.data?.internal_projects?.map(
                                        (item: any) => <p>{item?.title_en}</p>
                                      )
                                    : item?.data?.internal_projects?.map(
                                        (item: any) => <p>{item?.title_ar}</p>
                                      )
                                  : item?.data?.campaign_projects
                                  ? i18n.language === "en"
                                    ? item?.data?.campaign_projects.map(
                                        (item: any) => <p>{item?.title_en}</p>
                                      )
                                    : item?.data?.campaign_projects.map(
                                        (item: any) => <p>{item?.title_ar}</p>
                                      )
                                  : item?.data?.external_projects
                                  ? i18n.language === "en"
                                    ? item?.data?.external_projects.map(
                                        (item: any) => <p>{item?.title_en}</p>
                                      )
                                    : item?.data?.external_projects.map(
                                        (item: any) => <p>{item?.title_ar}</p>
                                      )
                                  : item?.data?.humanitarian_projects
                                  ? i18n.language === "en"
                                    ? item?.data?.humanitarian_projects.map(
                                        (item: any) => <p>{item?.title_en}</p>
                                      )
                                    : item?.data?.humanitarian_projects.map(
                                        (item: any) => <p>{item?.title_ar}</p>
                                      )
                                  : item?.data?.orphan_projects
                                  ? i18n.language === "en"
                                    ? item?.data?.orphan_projects.map(
                                        (item: any) => <p>{item?.title_en}</p>
                                      )
                                    : item?.data?.orphan_projects.map(
                                        (item: any) => <p>{item?.title_ar}</p>
                                      )
                                  : item?.data?.seasonal_projects
                                  ? i18n.language === "en"
                                    ? item?.data?.seasonal_projects.map(
                                        (item: any) => <p>{item?.title_en}</p>
                                      )
                                    : item?.data?.seasonal_projects.map(
                                        (item: any) => <p>{item?.title_ar}</p>
                                      )
                                  : ""}
                              </p>
                            </div>
                          </div>
                        </td>

                        {/* AMOUNT ************/}
                        <td className="lg:px-5 lg:py-5 border-b border-gray-200 bg-white text-[8px] lg:text-[16px] shadow-shadow_main">
                          <div className="flex">
                            <div className="ml-3">
                              <p className=" whitespace-no-wrap text-first_color font-[700]">
                                {item?.data?.internal_projects
                                  ? item?.data?.internal_projects?.map(
                                      (item: any) => (
                                        <p>
                                          {item?.amount} {t("AED")}
                                        </p>
                                      )
                                    )
                                  : item?.data?.campaign_projects
                                  ? item?.data?.campaign_projects?.map(
                                      (item: any) => (
                                        <p>
                                          {item?.amount} {t("AED")}
                                        </p>
                                      )
                                    )
                                  : item?.data?.external_projects
                                  ? item?.data?.external_projects?.map(
                                      (item: any) => (
                                        <p>
                                          {item?.amount} {t("AED")}
                                        </p>
                                      )
                                    )
                                  : item?.data?.humanitarian_projects
                                  ? item?.data?.humanitarian_projects?.map(
                                      (item: any) => (
                                        <p>
                                          {item?.amount} {t("AED")}
                                        </p>
                                      )
                                    )
                                  : item?.data?.orphan_projects
                                  ? item?.data?.orphan_projects?.map(
                                      (item: any) => (
                                        <p>
                                          {item?.amount} {t("AED")}
                                        </p>
                                      )
                                    )
                                  : item?.data?.seasonal_projects
                                  ? item?.data?.seasonal_projects?.map(
                                      (item: any) => (
                                        <p>
                                          {item?.amount} {t("AED")}
                                        </p>
                                      )
                                    )
                                  : ""}
                              </p>
                            </div>
                          </div>
                        </td>

                        {/* DATE & TIME ***************/}
                        <td className="lg:px-5 lg:py-5 border-b border-gray-200 bg-white text-[8px] lg:text-[16px] shadow-shadow_main">
                          <div className="flex">
                            <div className="ml-3">
                              <p className="text-black font-[500] whitespace-no-wrap">
                                {item?.summary?.created_on}
                              </p>
                            </div>
                          </div>
                        </td>

                        {/* status **********/}
                        {item?.summary?.status === "FAILED" ? (
                          <td className="font-[700] text-[#E00101] min-w-[40px] lg:min-w-[80px] lg:px-5 lg:py-5 border-b border-gray-200 bg-white text-[8px] lg:text-[16px] shadow-shadow_main">
                            <img src={closered} alt="" className="w-[18px]" />
                          </td>
                        ) : (
                          <td className="font-[700] text-[#1FC024] min-w-[40px] lg:min-w-[80px] lg:px-5 lg:py-5 border-b border-gray-200 bg-white text-[8px] lg:text-[16px] shadow-shadow_main">
                            <img src={checkMark} alt="" className="w-[30px]" />
                          </td>
                        )}

                        {/* downloadReceipt *******/}
                        {item?.summary?.receipt_url && (
                          <td className="lg:px-5 lg:py-5 border-b border-gray-200 bg-white text-[8px] lg:text-[16px] shadow-shadow_main ">
                            <div className="flex">
                              <div className="ml-3">
                                <p
                                  onClick={() => {
                                    window.open(
                                      `${item?.summary?.receipt_url}`
                                    );
                                  }}
                                  className="font-[700] text-first_color whitespace-no-wrap flex items-center gap-2 cursor-pointer"
                                >
                                  {t("Download")}{" "}
                                  <img
                                    className="w-[20px]"
                                    src={downloadReceipt}
                                    alt=""
                                  />
                                </p>
                              </div>
                            </div>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </section>
        </Spin>
      </main>

      <Footer />
    </>
  );
};

export default Donations;
